// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1PhQo","header":"PatientBlock_header__2s1s4","label":"PatientBlock_label__2k-Ob","option":"PatientBlock_option__1kNXh"};